/**
 * Funnelback.ts
 */
import LazyLoad from 'vanilla-lazyload';
import { log } from '../../../dist/a11y-issue-logger';

const Funnelback = (() => {

    let options = {
        initElem: document.getElementsByClassName('js-funnelback')
    }

    function init() {

        if(options.initElem.length) {

            // Funnelback settings
            let collection = 'myflexed-db-test';
            let URL = 'https://fback-sp.is.strath.ac.uk';
            
            // Catalogue page
            if(document.getElementById('search-module') !== null) {

                let request = URL + '/s/search.json?query=%21nullquery&profile=_default&collection=' + collection + '&num_ranks=200';

                // Parameters from homepage search
                let searchParams = new URLSearchParams(window.location.search);
                let searchWord = searchParams.get('searchModule');

                if(searchWord !== '!nullquery') {
                    initFB(collection, URL, request, searchWord);
                } else {
                    initFB(collection, URL, request, null);
                }

                suggestions(collection, URL, 'search-module');
                resetAll(request);
                preventSubmit();
            }

            // Homepage
            if(document.getElementById('search-modules') !== null) {
                suggestions(collection, URL, 'search-modules');
                redirectCatalogue();
            }
            
            if(EWDS_DEBUG) {
                console.log('[DEBUG] Funnelback : initialized');
            }
        }

    }


    /**
     * Initialize Funnelback search & filter
     */
    function initFB(collection: string, URL: RequestInfo | URL, request: RequestInfo | URL, searchWord: null)
    {

        if(searchWord == null) {
            displayHTML(request, null);
        } else {
            searchParam(collection, URL, searchWord);
        }

        // Search & filter
        search(request, collection, URL);
        filter(request, collection, URL);

    }

    /** 
     * Set Suggest
     */
    function suggestions(collection: string, URL: RequestInfo | URL, field: string)
    {
        const search = document.getElementById(field);

        if(search != null) {

            search.addEventListener('keyup', function(){
                const elem = document.getElementById('list-suggestions');

                if(search.value != '' && search.value.length > 0) {
                    // let request = URL + '/s/suggest.json?partial_query=' + search.value + '&profile=_default_preview&collection=' + collection;
                    let request = URL + '/s/suggest.json?&profile=_default_preview&alpha=1&show=5&collection=' + collection + '&partial_query=' + search.value;

                    fetch(request, { headers: { "Content-Type": "application/json; charset=utf-8" }})
                        .then(res => res.json())
                        .then(response => {

                            let results = response;
                            let html = '';

                            elem.innerHTML = "";
                            
                            if(results.length > 0) {

                                for (const item of results) {
                                    html += '<li data-suggestion="' + item + '">' + item + '</li>';
                                }

                                elem.style.display = 'block';
                                elem.insertAdjacentHTML('beforeend', html);

                                var listItems = document.querySelectorAll("#list-suggestions li");

                                listItems.forEach(item => {
                                    item.addEventListener("click", () => {
                                        let searchWord = item.dataset.suggestion;
                                        search.value = searchWord;
                                        elem.style.display = 'none';
                                        
                                        // Disables now : redirect when user click suggested list
                                        // if(searchWord!= '') {
                                        //     window.location = '/Catalogue?searchModule=' + searchWord;
                                        // }

                                        if(field == 'search-module'){
                                            console.log(searchWord);
                                            searchParam(collection, URL, searchWord);
                                        }
                                        
                                    });
                                });

                            } else {
                                elem.style.display = 'none';
                            }
                    })
                    .catch(err => {
                        elem.insertAdjacentHTML('beforeend', 'Error occured.');
                    });

                } else {
                    elem.style.display = 'none';
                }

            });

            // search.addEventListener('blur', function() {
            //     let elem = document.getElementById('list-suggestions');
            //     elem.style.display = 'none';
            // });
        }
    }


    /**
     * Set Funnelback Request URL with Catalogue search
     * @param collection 
     * @param URL 
     * @param request 
     */
    function search(request: RequestInfo | URL, collection: string, URL: RequestInfo | URL) 
    {

        let nullRequest = request;
        const search = document.getElementById('search-module');

        if (search != null) {
            // remove filter checks before using search box
            search.addEventListener('click', function(){
                
                if(search.value == '') {
                    let count = 0;
                    const filter = document.querySelectorAll('input[type=checkbox]');

                    for (let index = 0; index < filter.length; index++) {
                        let item = filter[index];

                        if(item.checked) {
                            count++;
                            item.checked = false;
                        }
                    }

                    if(count > 0) {
                        displayHTML(nullRequest, this.value);
                    }

                }                
            });

            search.addEventListener('keyup', function(event) {

                if(this.value.length > 2) {
                    request = URL + '/s/search.json?query=' + this.value + '&profile=_default&collection=' + collection + '&num_ranks=200';
                } else {
                    request = nullRequest;
                }       
    
                displayHTML(request, this.value);
            });

        } else {            
            displayHTML(nullRequest, null);
        }

    }

    /**
     * Set Funnelback Request URL with filters
     * @param collection 
     * @param URL 
     * @param request 
     */
    function filter(request: RequestInfo | URL, collection: string, URL: RequestInfo | URL)
    {

        let nullRequest = request;
        let groups = document.getElementsByClassName('catalogue-filter__child');

        // Default variables
        let subjectAry = [],
            levelAry = [],
            availableAry = [];

        let subjectParam = '%21nullquery';
        let levelParam = '%21nullquery';
        let availableParam = '%21nullquery';
        
        for(let index = 0; index < groups.length; index++) {

            let group = groups[index];
            let filterName = group.dataset.filterGroup;

            let selectors = document.querySelectorAll('.' + filterName);

            selectors.forEach(function(selector) {
                selector.addEventListener('change', function (event) {

                    // Clear text from search field
                    const search = document.getElementById('search-module');
                    search.value = '';
                    
                    if (this.checked) {

                        switch(filterName) {
                            case 'subject':
                                subjectAry.push('&f.subject%7Csubject=' + this.value);
                                subjectParam = subjectAry.join('');
                                break;
                            case 'modulelevel':
                                levelAry.push('&f.modulelevel%7Cmodulelevel=' + this.value);
                                levelParam = levelAry.join('');
                                break;
                            case 'availability':
                                availableAry.push('&f.availability%7Cavailability=' + this.value);
                                availableParam = availableAry.join('');
                            break;
                        }
                        
                    } else {

                        switch(filterName) {
                            case 'subject':
                                subjectAry = subjectAry.filter(item => item !== '&f.subject%7Csubject=' + this.value);
                                subjectParam = (subjectAry.length > 0) ? subjectAry.join('') : '%21nullquery';
                                break;
                            case 'modulelevel':
                                levelAry = levelAry.filter(item => item !== '&f.modulelevel%7Cmodulelevel=' + this.value);
                                levelParam = (levelAry.length > 0) ? levelAry.join('') : '%21nullquery';
                                break;
                            case 'availability':
                                availableAry = availableAry.filter(item => item !== '&f.availability%7Cavailability=' + this.value);
                                availableParam = (availableAry.length > 0) ? availableAry.join('+') : '%21nullquery';
                            break;
                        }
                        
                    }

                    if(subjectAry.length == 0 && levelAry.length == 0 && availableAry.length == 0) {
                        request = nullRequest;
                    } else {

                        let levelString = (levelAry.length > 0) ? levelParam : '';
                        let subjectString = (subjectAry.length > 0) ? subjectParam : '';
                        let availString = (availableAry.length > 0) ? availableParam : '';

                        request = URL + '/s/search.json?query=%21nullquery&profile=_default&collection=' + collection + '&num_ranks=200' + levelString + subjectString + availString;
                    }                    
                    
                    displayHTML(request, null);
                    
                });
            });           
            
        }
        
    }

    /**
     * Redirect to Catalogue page from Homepage Module Search
     */
    function redirectCatalogue()
    {
        const search = document.getElementById('search-modules');
        const button = document.getElementById('search-modules-button');

        button.addEventListener('click', function(event) {
            event.preventDefault();

            let params = '?searchModule=';
            
            if(search.value.length > 2) {
                params += search.value;
            } else {
                params += '%21nullquery';
            }       

            window.location = '/Catalogue' + params;
        });
    }

    /**
     * Set Funnelback Request URL with Homepage Module Search
     * @param collection 
     * @param URL 
     * @param searchWord 
     */
    function searchParam(collection: string, URL: RequestInfo | URL, searchWord: string)
    {
        let request = '';
        const search = document.getElementById('search-module');
        search.value = searchWord;

        if(searchWord.length > 2) {
            request = URL + '/s/search.json?query=' + searchWord + '&profile=_default&collection=' + collection + '&num_ranks=200';
        } else {
            request = URL + '/s/search.json?query=%21nullquery&profile=_default&collection=' + collection + '&num_ranks=200';
        }

        // remove parameter
        window.history.replaceState(null, '', window.location.pathname);

        displayHTML(request, searchWord);
    }

    /**
     * Fetch Json data and display with HTML
     * @param request 
     * @param searchWord 
     */
    function displayHTML(request: RequestInfo | URL, searchWord : null)
    {

        let elem = document.getElementById('catalogue-cards');
        elem.innerHTML = '<div style="width: 100%;display:flex;justify-content:center;"><img src="/Portals/_default/Skins/2shineBS5/images/loading.gif" alt="Module occurrence loading" style="width:150px;" /></div>';

        fetch(request, { headers: { "Content-Type": "application/json; charset=utf-8" }})
            .then(res => res.json()) // parse response as JSON (can be res.text() for plain response)
            .then(response => {

                let results = response.response.resultPacket.results;
                let html = '';

                elem.innerHTML = "";
                
                if(results.length > 0) {

                    // Count the not null items
                    // DO NOT USE : results.length - this includes extra null result.
                    var resultsCnt = 0

                    for(var i in results) {
                        let obj =  results[i].metaData;
                        
                        if(obj.slug != '__NULL__')
                            resultsCnt++;
                    }

                    if(searchWord == null || searchWord == '!nullquery'  ) {
                        html += (resultsCnt == 1) ? '<div class="result-header"><p><strong>' + resultsCnt + '</strong> result found</p></div>': '<div class="result-header"><p><strong>' + resultsCnt + '</strong> results found</p></div>';
                    } else {
                        html += (resultsCnt == 1) ? '<div class="result-header"><p class="search-result__title"><strong>' + resultsCnt + '</strong> result found for <strong>' + searchWord + '</strong></p></div>': '<div class="result-header"><p><strong>' + resultsCnt + '</strong> results found for <strong>' + searchWord + '</strong></p></div>';
                    }

                    for(var i in results) {
                        
                        let obj =  results[i].metaData;

                        if(obj.slug == '__NULL__')
                            continue;

                        let img = (obj.uploadurl == '__NULL__') ? '/Portals/_default/Skins/2shineBS5/images/placeholder/UoS-Stenhouse-Wing-640-360.jpg' : obj.uploadurl;
                        
                        // console.log(obj);
    
                        html += '<a href="/Catalogue/Module/id/' + obj.slug +'" title="' + obj.t +'" class="catalogue-card ewds-container-bg">';
                        html += '<div class="catalogue-card__body"><h3>' + obj.t + '</h3>';
                        html += (obj.c == '__NULL__') ? '' : '<p>' + obj.c + '</p>';
                        html += '</div>';
                        html += '<div class="catalogue-card__footer">';
                        html += '<ul>';
                        html += (obj.modulelevel == '__NULL__') ? '' :'<li title="Level"><i class="fas fa-graduation-cap"></i>' + obj.modulelevel +'</li>';
                        html += (obj.duration == '__NULL__') ? '' :'<li title="Duration"><i class="far fa-clock"></i>' + obj.duration +'</li>';
                        html += (obj.days == '__NULL__') ? '' :'<li title="Days"><i class="far fa-calendar-alt"></i>' + obj.days +'</li>';
                        html += (obj.fee == '__NULL__') ? '' :'<li title="Fee"><i class="fas fa-pound-sign"></i>' + obj.fee +'</li>';
                        html += (obj.opendays == '__NULL__' || obj.opendays == 0) ? '' :'<li title="Registration Open"><i class="far fa-calendar"></i>' + obj.opendays + ((obj.opendays == 1)? ' date' : ' dates') + ' available</li>';
                        
                        if(obj.modulefunding == '__NULL__') {
                            html += '';
                        } else if (obj.modulefunding == '0' || obj.modulefunding == 0) {
                            html += '<li title="Funding"><i class="fas fa-hand-holding-usd"></i>No Funding</li>';
                        } else {
                            html += '<li title="Funding"><i class="fas fa-hand-holding-usd"></i>SFC Funding</li>';
                        }
    
                        html += '</ul>';
                        html += '</div>';
                        html += '<figure class="catalogue-card__image"><img class="lazy" data-src="' + img + '" alt=""></figure>'
                        html += '</a>';
                    }

                    elem.insertAdjacentHTML('beforeend', html);

                    let myLazyLoad = new LazyLoad();

                } else {
                    elem.innerHTML = "";

                    if(searchWord == null) {
                        elem.insertAdjacentHTML('beforeend', '<div class="result-header"><p>Sorry! No results found :(</p></div>');
                    } else {
                        elem.insertAdjacentHTML('beforeend', '<div class="result-header"><p style="margin-bottom: 1rem;">Sorry! No results for <strong>' + searchWord + '</strong> :(</p><h3>Suggestions:</h3><ul class="list-default"><li>Make sure all words are spelled correctly.</li><li>Try different keywords.</li></ul></div>');
                    }
                    
                }
                
            })
            .catch(err => {
                elem.insertAdjacentHTML('beforeend', 'Error occured.');
            });

    }

    /**
     * Reset search box and filter then display all modules
     * @param request 
     */
    function resetAll(request: RequestInfo | URL) {

        const resetButton = document.querySelector('button[type="reset"]');
        const search = document.getElementById('search-module');
        const filter = document.querySelectorAll('input[type=checkbox]');

        if(resetButton !== null) {

            resetButton.addEventListener('click', function(event) {
                // console.log(event);
                
                let count = 0;

                // empty search box        
                if(search.value.length > 0) {
                    count++;
                    search.value = '';
                }
        
                // uncheck all checkbox        
                for (let index = 0; index < filter.length; index++) {
                    let item = filter[index];
        
                    if(item.checked) {
                        count++;
                        item.checked = false;
                    }
                }
        
                if(count > 0) {
                    displayHTML(request, this.value);
                }
            });

        }

    }
    
    function preventSubmit() {
        window.addEventListener('keydown', function(event) {
            if (event.keyIdentifier == 'U+000A' || event.keyIdentifier == 'Enter' || event.keyCode == 13) {
                
                if (event.target.nodeName == 'INPUT' && event.target.type == 'text') {                    
                    event.preventDefault();
                    return false;
                }
            }
        }, true);
    }

    return {
        init: init
    };

})();

export default Funnelback;